import { computed } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { System } from '@/router/config/roles';
import { LINC_ENTERPRISE_ID, isLincAgent } from '@/router/config/route-access';

/**
 * 候补者情报里几个模块的可见性判断，编辑页与详情页共用，保证两边一致：
 * - 求职诉求（猎头端字段）/ 现职收入：所有猎头可见 → showAgentSections
 * - 现状调研 / 分類（用户标签）：仅株式会社 Linc 可见 → showHunterOnlySections
 */
export function useHunterOnlySections() {
  const userStore = useUserStore();

  // 猎头端
  const isAgent = computed(() => userStore.userSystem === System.agent);

  // 「株式会社 Linc」：企业 ID 固定为 1000019
  const isLincCompany = computed(() => Number(userStore.enterpriseId) === LINC_ENTERPRISE_ID);

  // 所有猎头可见（求职诉求的猎头端字段 / 现职收入）
  const showAgentSections = isAgent;

  // 仅猎头端的株式会社 Linc 可见（现状调研 / 分類 / 用户标签）
  // 与路由 meta.access 共用同一判断，页面内显隐和路由拦截保持一致
  const showHunterOnlySections = computed(() => isLincAgent({
    userSystem: userStore.userSystem,
    enterpriseId: userStore.enterpriseId,
  }));

  return { isAgent, isLincCompany, showAgentSections, showHunterOnlySections };
}
